import { dueTone } from './pending';

// Helpers de la agenda mensual (admin-kpis.md ?view=schedule · 0110). A diferencia de
// `pending` (ventana de cohorte OPU), acá la cohorte se ancla en la TAREA por mes:
// incluye embriones externos y expone dx3plus. Cada bloque (schedule/overdue) es
// { dx1:[], dx2:[], dx3plus:[], births:[] } con items planos (con `done`).

export const SCHEDULE_TYPES = {
    dx1:     { key: 'dx1',     label: 'Dx 1',   dateKey: 'scheduled_for', color: '#04c2a0' },
    dx2:     { key: 'dx2',     label: 'Dx 2',   dateKey: 'scheduled_for', color: '#3bb5ed' },
    dx3plus: { key: 'dx3plus', label: 'Dx 3+',  dateKey: 'scheduled_for', color: '#8b5cf6' },
    births:  { key: 'births',  label: 'Partos', dateKey: 'expected',      color: '#f59e0b' },
};
export const SCHEDULE_TYPE_KEYS = ['dx1', 'dx2', 'dx3plus', 'births'];

// Fechas posibles por tipo (tolerante a drift doc↔impl del backend).
const DATE_KEYS = { births: ['expected', 'due', 'estimated', 'born_on'], _dx: ['scheduled_for', 'date', 'due'] };
const pickDate = (it, type) => (type === 'births' ? DATE_KEYS.births : DATE_KEYS._dx).map((k) => it?.[k]).find(Boolean) || null;

// Lista de items de un tipo, tolerando la forma: array directo (contrato) | { items } |
// { overdue, upcoming } (estilo pending). Así los dx se levantan aunque el backend los anide.
export function listOf(block, key) {
    const v = block?.[key];
    if (Array.isArray(v)) return v;
    if (!v || typeof v !== 'object') return [];
    if (Array.isArray(v.items)) return v.items;
    return [...(v.overdue?.items ?? v.overdue ?? []), ...(v.upcoming?.items ?? v.upcoming ?? [])];
}

// Aplana un bloque (schedule u overdue) en eventos con tipo, fecha, tono, done y contexto.
// `bucket` = 'scheduled' (del mes) | 'overdue' (arrastre). Un evento done → tono 'done'.
export function flattenSchedule(block = {}, bucket = 'scheduled') {
    const out = [];
    for (const key of SCHEDULE_TYPE_KEYS) {
        listOf(block, key).forEach((it, i) => {
            const date = pickDate(it, key);
            out.push({
                id: `${bucket}-${key}-${it.diagnostic_id ?? it.pregnancy_id ?? it.transfer_id ?? i}`,
                type: key,
                bucket: bucket === 'overdue' ? 'overdue' : 'upcoming', // reusa el semáforo del calendario
                date,
                done: !!it.done,
                tone: it.done ? 'done' : dueTone(date),
                result: it.result ?? null,
                born_on: it.born_on ?? null,
                calf_id: it.calf_id ?? null,
                recipient: it.recipient, opu: it.opu, te_session: it.te_session, farm: it.farm,
                raw: it,
            });
        });
    }
    return out;
}

// Conteos por tipo del bloque del mes: { dx1:{total,done,pending}, … } + gran total.
export function scheduleCounts(schedule = {}) {
    const counts = {};
    let total = 0; let done = 0;
    for (const key of SCHEDULE_TYPE_KEYS) {
        const list = listOf(schedule, key);
        const d = list.filter((x) => x.done).length;
        counts[key] = { total: list.length, done: d, pending: list.length - d };
        total += list.length; done += d;
    }
    counts.total = total; counts.done = done; counts.pending = total - done;
    return counts;
}
